module.exports = __webpack_public_path__ + "static/vf_wskirt_core.abc55e0c.svg";